import { Component } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage/storage.service';
import { StorageKeys } from '../../shared/enums/storage.enum';
import { RouteConstants } from '../../shared/constants/routes.constants';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../environments/environments';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  faSpinner = faSpinner;
  errorMsg: string = '';
  googleLoading: boolean = false;
  microsoftLoading: boolean = false;
  isReturningUser: boolean = false;
  isStudio: boolean = environment.envType === 'STUDIO';
  welcomeText: string = environment.envType === 'STUDIO' ? 'Welcome to SDEX - Studio' : 'Welcome to SDEX - eSign';

  constructor(
    private authService: AuthService,
    private router: Router,
    private storageService: StorageService,
  ) { }

  ngOnInit() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      this.storageService.setDataToLocalStorage(StorageKeys.ACCESS_TOKEN, token);
      this.getSelfDetails();
    }
  }

  signUp(provider: string) {
    if (provider === 'google') {
      this.googleLoading = true;
    } else {
      this.microsoftLoading = true;
    }
    const webEnv = environment.envType; // STUDIO / ESIGN
    window.location.href = `${environment.API_URL}/v1/auth/${provider}?webEnv=${webEnv}`;
  }

  getSelfDetails() {
    this.errorMsg = '';
    this.googleLoading = true;
    this.authService.getSelfDetails().subscribe({
      next: (res) => {
        if (res?.data) {
          this.storageService.setDataToLocalStorage(
            StorageKeys.SELF_DETAILS,
            res.data
          );
          this.authService.setUser(res.data);
          const homeRoute = environment.envType === 'ESIGN'
            ? RouteConstants.History
            : RouteConstants.CategoryList;
          this.router.navigate([homeRoute]);
        } else {
          this.errorMsg = 'Invalid user data received';
        }
        this.googleLoading = false;
      },
      error: (err) => {
        this.googleLoading = false;
        this.errorMsg = err?.error?.error?.message || 'Failed to fetch user details';
        console.error('Error fetching self details:', err);
      }
    });
  }

}
